<template>
    <div class="share-bar">
        <div class="share-bar__title">
            Partager
        </div>
        <div class="share-bar__content">
            <a :href="facebookShareUrl"
               class="share-bar__facebook facebook-share"
               target="_blank"
            ><span class="share-bar__social-label">Facebook</span></a>

            <a :href="twitterShareUrl"
               class="share-bar__twitter twitter-share"
               target="_blank"
            ><span class="share-bar__social-label">Twitter</span></a>

            <a :href="linkedInShareUrl"
               class="share-bar__linkedin linkedin-share"
               target="_blank"
            ><span class="share-bar__social-label">LinkedIn</span></a>

            <a :href="emailShareUrl"
               class="share-bar__mail mail-share"
            ><span class="share-bar__social-label">Email</span></a>

            <a v-if="pdfFile"
               :href="pdfFile"
               target="_blank"
               class="share-bar__pdf"
            >Télécharger le PDF</a>

            <a v-if="mediathequeFileExists"
               :href="mediathequeFile"
               target="_blank"
               class="share-bar__mediatheque"
            >Récupérer les médias</a>
        </div>
    </div>
</template>

<script>
    import newsDetailsFilesMixin from '@/mixins/news-details-files';

    export default {
        name: 'ShareBar',

        mixins: [ newsDetailsFilesMixin ],

        props: {
            shareUrl: { type: String, required: true },
        },

        computed: {
            encodedShareUrl () {
                return encodeURIComponent(this.shareUrl);
            },

            twitterShareUrl () {
                const shareText = 'TODO';
                return `https://twitter.com/intent/tweet?text=${shareText}&url=${this.encodedShareUrl}`;// FIXME: Ajouter le texte du tweet lors du partage
            },

            facebookShareUrl () {
                return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedShareUrl}`;
            },

            linkedInShareUrl () {
                return `https://www.linkedin.com/sharing/share-offsite/?url=${this.encodedShareUrl}`;
            },

            emailShareUrl () {
                const subject = encodeURIComponent('TODO: Changer le sujet du mail de partage');
                const body = encodeURIComponent(`TODO: Changer le corps du mail de partage.\n\n${this.shareUrl}`);
                return `mailto:?subject=${subject}&body=${body}`;
            },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_functions';
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .share-bar {
        a {
            color: #575757;
        }

        &__title {
            @extend %font-OpenSans-regular;
            font-size: 1.2rem;

            @include media-breakpoint-up(sm) {
                display: none;
            }
        }

        &__content {
            display:        flex;
            flex-direction: row;
            align-items:    center;

            > *:not(:first-child) {
                margin-left: 3rem;
                margin-top:  1rem;

                @include media-breakpoint-up(sm) {
                    margin-left: 2rem;
                    margin-top:  0;
                }
            }
        }

        &__facebook::before {
            content: url('~@/assets/images/facebook-grey.png');
        }
        &__twitter::before {
            content: url('~@/assets/images/twitter-grey.png');
        }
        &__linkedin::before {
            content: url('~@/assets/images/linkedin-grey.png');
        }
        &__mail::before {
            content: url('~@/assets/images/mail-grey.png');
        }

        &__facebook,
        &__twitter,
        &__linkedin,
        &__mail {
            position: relative;
            top:      0.5rem;
        }

        &__social-label {
            @include sr-only;
        }

        &__pdf::before {
            content: url('~@/assets/images/download-grey.png');
        }

        &__mediatheque::before {
            content: url('~@/assets/images/image-grey.png');
        }

        &__mediatheque, &__pdf {
            &::before {
                position:     relative;
                top:          0.6rem;

                margin-right: 1em;
            }

            @include media-breakpoint-down(xs) {
                display: none;
            }
        }
    }
</style>
